<template>
    <div class="change-password" v-if="value">
        <app-header @go-back="handleGoBack" hideNavIcon></app-header>
        <div class="body-padding">
            <div class="field-group">
                <cus-field :value="mobile" disabled>
                    <span v-if="count === 0" slot="right" class="send-code" @click="handleSendCode">发送验证码</span>
                    <span v-else slot="right" class="send-code" @click="handleSendCode">验证码已发送({{count}})</span>
                </cus-field>
                <cus-field placeholder="请输入验证码" v-model="code"></cus-field>
                <cus-field type="password" placeholder="请输入新密码(6~20位英文或数字)" v-model="password"></cus-field>
                <cus-field type="password" placeholder="请再次输入新密码" v-model="verify"></cus-field>
            </div>
            <div class="wrap-btn">
                <van-button type="warning" round :disabled="disabled" @click="handleSave">保存</van-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ChangePassword",
        props: {
            value: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                mobile: this.$store.state.mobile,
                count: 0,
                code: '',
                password: '',
                verify: '',
            }
        },
        computed: {
            disabled () {
                if (!this.code) return true
                if (this.password.length < 6 || this.password.length > 20) return true
                return this.verify !== this.password
            },
        },
        components: {
            AppHeader: () => import('@/components/common/header/Header')
        },
        methods: {
            handleSendCode() {
                if (this.count !== 0) return
                let params = {
                    mobile: this.mobile
                }
                this.$toast.loading({
                    duration: 0,
                    message: '短信发送中...',
                    mask: true
                })
                this.$axios({
                    url: 'user/captcha',
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    },
                    params
                }).then(() => {
                    let TIME_COUNT = 60
                    let count = TIME_COUNT
                    this.count = 60
                    this.timer = setInterval(() => {
                        if (count > 1 && count <= TIME_COUNT) {
                            count--
                            this.count = count
                        } else {
                            clearInterval(this.timer)
                            this.timer = null
                            this.count = 0
                        }
                    }, 1000);
                    this.$toast.clear()
                })
            },
            handleGoBack() {
                this.$emit('input', !this.value)
            },
            handleSave() {
                let params = {
                    params: {
                        mobile: this.mobile,
                        code: this.code,
                        password: this.password,
                        loginType: 5
                    }
                }
                this.$toast.loading({
                    duration: 0,
                    mask: true,
                    message: '加载中...'
                })
                this.$axios.post('user/check', params).then(res => {
                    return this.$axios({
                        url: 'user/retrieve/password',
                        params: params.params,
                        headers: {
                            'Content-Type': 'application/form-data;charset=UTF-8'
                        },
                        method: 'post'
                    })
                }).then(() => {
                    this.$dialog.alert({
                        message: '修改成功, 请重新登录!'
                    }).then(() => {
                        this.$store.commit('logout')
                        this.$router.push({name: 'Login'})
                    })
                    this.$toast.clear()
                }).catch(err => {
                    this.$toast.clear()
                    this.$toast({
                        message: err.data.msg,
                        duration: 1000
                    })
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .change-password{
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: #e5e5e5;
    }
    .wrap-btn {
        margin-top: 0.49rem;
        text-align: center;
    }
    .send-code {
        color: #FE9329;
        font-size: 0.4rem;
    }
</style>
